import { createI18n } from 'vue-i18n'

import uz from '@/locales/uz.json'
import uz_cyrl from '@/locales/uz_cyrl.json'

const i18n = createI18n({
  legacy: false,
  locale: localStorage.getItem('locale') || 'uz',
  fallbackLocale: 'uz',
  globalInjection: true,
  messages: {
    uz,
    uz_cyrl
  }
})

export default i18n